import * as React from 'react';

import type {
  SectionsItem,
  STEP_QUESTIONNAIRE_SECTIONS_RESPONSE,
  FEEDBACK_CONFIG_RESPONSE,
  Review,
  JobStageStep,
} from 'src/types/crm';

import EvaluationSubjectiveQuestionsView from './evaluation-subjective-questions-view';


const EvaluationFormView = ({
  scorecardStepSections,
  subjectiveSections,
  feedbackConfiguration,
  review,
  step,
  token,
  tokenId,
  // @ts-expect-error - TS2339 - Property 'forPdf' does not exist on type '{ scorecardStepSections: (SectionsItem & { status: string; })[]; subjectiveSections: STEP_QUESTIONNAIRE_SECTIONS_RESPONSE[]; feedbackConfiguration: FEEDBACK_CONFIG_RESPONSE; review: Review; step: JobStageStep; token?: string | undefined; tokenId?: string | undefined; }'.
  forPdf = false,
}: {
  scorecardStepSections: Array<
    SectionsItem & {
      status: string;
    }
  >;
  subjectiveSections: Array<STEP_QUESTIONNAIRE_SECTIONS_RESPONSE>;
  feedbackConfiguration: FEEDBACK_CONFIG_RESPONSE;
  review: Review;
  step: JobStageStep;
  token?: string;
  tokenId?: string;
}) => {
  const {reviewStatus, comment, feedbackScores} = review;

  const answers = (review.answers || []).reduce<Record<string, any>>(
    (acc, item) => {
      acc[item.questionId] = item.answer;
      return acc;
    },
    {},
  );

  const hideScorecard = step.hideScorecard;

  return (
    <>
      <EvaluationSubjectiveQuestionsView
        subjectiveSections={subjectiveSections}
        answers={answers}
        token={token}
        tokenId={tokenId}
        review={review}
        comment={comment}
        feedbackConfiguration={feedbackConfiguration}
        reviewStatus={reviewStatus}
        // @ts-expect-error - TS2322 - Type '(SectionsItem & { status: string; })[]' is not assignable to type 'never[]'.
        scorecardStepSections={scorecardStepSections}
        // @ts-expect-error - TS2322 - Type '{ id: number; createdBy: number; createdOn: number; updatedBy: number; updatedOn: number; organizationId: number; reviewId: number; parameterId: number; score: number; new: boolean; }[]' is not assignable to type 'never[]'.
        feedbackScores={feedbackScores}
        hideScorecard={hideScorecard}
        step={step}
        forPdf={forPdf}
      />
    </>
  );
};

export default EvaluationFormView;
